import { logClientPushEvent } from "../server/push.functions"

type PushDiagnostic = {
  stage: string
  outcome: string
  elapsedMs: number
  error?: unknown
}

const errorDetails = (error: unknown) =>
  error instanceof Error ? { name: error.name, message: error.message } : undefined

export const logPushDiagnostic = ({ error, ...diagnostic }: PushDiagnostic) => {
  const permission = typeof Notification === "undefined" ? undefined : Notification.permission
  const userAgent = typeof navigator === "undefined" ? undefined : navigator.userAgent
  void logClientPushEvent({
    data: { event: "push_diagnostic", ...diagnostic, ...errorDetails(error), permission, userAgent },
  }).catch(() => undefined)
}
